import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWardrobe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"wardrobe"} maskId="square-filled-radius-0-stroke-1-IconWardrobe"><path fillRule="evenodd" clipRule="evenodd" d="M11.5 2H4V20H6V22H7V20H11.5V2ZM10 9H9V13H10V9Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M18 20H20V2H12.5V20H17V22H18V20ZM15 9V13H14V9H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWardrobe;
